import { EsdtControlChanges } from "src/models/esdt/esdtControlChanges";
import { EsdtFreeze } from "src/models/esdt/esdtFreeze";
import { EsdtPause } from "src/models/esdt/esdtPause";
import { EsdtUnFreeze } from "src/models/esdt/esdtUnFreeze";
import { EsdtUnPause } from "src/models/esdt/esdtUnPause";
import { EsdtWipe } from "src/models/esdt/esdtWipe";
import { GetTokenInfo } from "src/models/esdt/getTokenInfo";
import { MultiversGetTxStatus } from "src/models/esdt/getTxStatus";
import { EsdtIssue } from "src/models/esdt/issue";
import { EsdtLocalBurn } from "src/models/esdt/localBurn";
import { EsdtLocalMint } from "src/models/esdt/localMint";
import { EsdtSetRole } from "src/models/esdt/setRole";
import { EsdtTransfer } from "src/models/esdt/transfer";
import { EsdtUnSetRole } from "src/models/esdt/unSetRole";
import { Credentials } from "src/models/instantiateClass";
import { MetaEsdtChangeNftToMetaEsdt } from "src/models/metaesdt/metaEsdtChangeNftToMetaEsdt";
import { MetaEsdtRegisterMetaEsdt } from "src/models/metaesdt/metaesdtRegisterMetaesdt";
import { GetCollectionInfo } from "src/models/nft/getCollectionInfo";
import { NftAddUri } from "src/models/nft/nftAddUri";
import { NftCreate } from "src/models/nft/nftCreate";
import { NftFreezeSingleNft } from "src/models/nft/nftFreezeSingleNft";
import { NftIssue } from "src/models/nft/nftIssue";
import { NftSetSpecialRole } from "src/models/nft/nftSetSpecialRole";
import { NftStopNftCreate } from "src/models/nft/nftStopNftCreate";
import { NftTransfer } from "src/models/nft/nftTransfer";
import { NftTransferNftCreateRole } from "src/models/nft/nftTransferNftCreateRole";
import { NftUnFreezeSingleNft } from "src/models/nft/nftUnFreezeSingleNft";
import { NftUpdateAttributes } from "src/models/nft/nftUpdateAttributes";
import { NftWipeSingleNft } from "src/models/nft/nftWipeSingleNft";
import { SftEsdtNftAddQuantity } from "src/models/sft/sftEsdtNftAddQuantity";
import { SftEsdtNftBurn } from "src/models/sft/sftEsdtNftBurn";
import { SftEsdtNftCreate } from "src/models/sft/sftEsdtNftCreate";
import { SftIssue } from "src/models/sft/sftIssue";
import { SftSetSpecialRole } from "src/models/sft/sftSetSpecialRole";
import { axiosRequest } from "./axiosCore";

// authorization header - obiect de authorization care sa aiba apiKey, authorization, env
export const esdtIssueToken = async (payload: EsdtIssue, initialize: Credentials) => {
   return await axiosRequest('/esdt/issue', payload, initialize);
}

export const esdtTrasferToken = async (payload: EsdtTransfer, initialize: Credentials) => {
   return await axiosRequest('/esdt/transfer', payload, initialize);
}

export const esdtSetRole = async (payload: EsdtSetRole, initialize: Credentials) => {
   return await axiosRequest('/esdt/setRole', payload, initialize);
}

export const esdtUnSetRole = async (payload: EsdtUnSetRole, initialize: Credentials) => {
   return await axiosRequest('/esdt/unsetRole', payload, initialize);
}

export const esdtLocalMint = async (payload: EsdtLocalMint, initialize: Credentials) => {
   return await axiosRequest('/esdt/localMint', payload, initialize);
}

export const esdtLocalBurn = async (payload: EsdtLocalBurn, initialize: Credentials) => {
   return await axiosRequest('/esdt/localBurn', payload, initialize);
}

export const esdtPause = async (payload: EsdtPause, initialize: Credentials) => {
   return await axiosRequest('/esdt/pause', payload, initialize);
}

export const esdtUnPause = async (payload: EsdtUnPause, initialize: Credentials) => {
   return await axiosRequest('/esdt/unPause', payload, initialize);
}

export const esdtFreeze = async (payload: EsdtFreeze, initialize: Credentials) => {
   return await axiosRequest('/esdt/freeze', payload, initialize);
}

export const esdtUnFreeze = async (payload: EsdtUnFreeze, initialize: Credentials) => {
   return await axiosRequest('/esdt/unFreeze', payload, initialize);
}

export const esdtWipe = async (payload: EsdtWipe, initialize: Credentials) => {
   return await axiosRequest('/esdt/wipe', payload, initialize);
}

export const esdtControlChanges = async (payload: EsdtControlChanges, initialize: Credentials) => {
   return await axiosRequest('/esdt/controlChanges', payload, initialize);
}

export const nftCreate = async (payload: NftCreate, initialize: Credentials) => {
   return await axiosRequest('/nft/mint', payload, initialize);
}

export const nftTransfer = async (payload: NftTransfer, initialize: Credentials) => {
   return await axiosRequest('/nft/transfer', payload, initialize);
}

export const nftIssue = async (payload: NftIssue, initialize: Credentials) => {
   return await axiosRequest('/nft/issue', payload, initialize);
}

export const nftSetSpecialRole = async (payload: NftSetSpecialRole, initialize: Credentials) => {
   return await axiosRequest('/nft/setSpecialRole', payload, initialize);
}

export const nftStopNftCreate = async (payload: NftStopNftCreate, initialize: Credentials) => {
   return await axiosRequest('/nft/stopNftCreate', payload, initialize);
}

export const nftTransferNftCreateRole = async (payload: NftTransferNftCreateRole, initialize: Credentials) => {
   return await axiosRequest('/nft/transferNFTCreateRole', payload, initialize);
}

export const nftUpdateAttributes = async (payload: NftUpdateAttributes, initialize: Credentials) => {
   return await axiosRequest('/nft/updateAttributes', payload, initialize);
}

export const nftAddUri = async (payload: NftAddUri, initialize: Credentials) => {
   return await axiosRequest('/nft/addUri', payload, initialize);
}

export const nftFreezeSingleNft = async (payload: NftFreezeSingleNft, initialize: Credentials) => {
   return await axiosRequest('/nft/freezeSingleNft', payload, initialize);
}

export const nftUnFreezeSingleNft = async (payload: NftUnFreezeSingleNft, initialize: Credentials) => {
   return await axiosRequest('/nft/unFreezeSingleNft', payload, initialize);
}

export const nftWipeSingleNft = async (payload: NftWipeSingleNft, initialize: Credentials) => {
   return await axiosRequest('/nft/wipeSingleNft', payload, initialize);
}

export const sftIssue = async (payload: SftIssue, initialize: Credentials) => {
   return await axiosRequest('/sft/sftIssue', payload, initialize);
}

export const sftEsdtNftCreate = async (payload: SftEsdtNftCreate, initialize: Credentials) => {
   return await axiosRequest('/sft/esdtNftCreate', payload, initialize);
}

export const sftSetSpecialRole = async (payload: SftSetSpecialRole, initialize: Credentials) => {
   return await axiosRequest('/sft/setSpecialRole', payload, initialize);
}

export const sftEsdtNftAddQuantity = async (payload: SftEsdtNftAddQuantity, initialize: Credentials) => {
   return await axiosRequest('/sft/esdtNftAddQuantity', payload, initialize);
}

export const sftEsdtNftBurn = async (payload: SftEsdtNftBurn, initialize: Credentials) => {
   return await axiosRequest('/sft/esdtNftBurn', payload, initialize);
}

export const metaEsdtRegisterMetaEsdt = async (payload: MetaEsdtRegisterMetaEsdt, initialize: Credentials) => {
   return await axiosRequest('/metaEsdt/registerMetaESDT', payload, initialize);
}

export const metaEsdtChangeNftToMetaEsdt = async (payload: MetaEsdtChangeNftToMetaEsdt, initialize: Credentials) => {
   return await axiosRequest('/metaEsdt/changeSFTToMetaESDT', payload, initialize);
}

export const multiversxGetTxStatus = async (payload: MultiversGetTxStatus, initialize: Credentials) => {
   return await axiosRequest('/multiversx/transactions/status', payload, initialize);
}

export const getCollectionInfo = async (payload: GetCollectionInfo, initialize: Credentials) => {
   return await axiosRequest('/multiversx/transactions/collection/info', payload, initialize);
}

export const getTokenInfo = async (payload: GetTokenInfo, initialize: Credentials) => {
   return await axiosRequest('/multiversx/transactions/token/info', payload, initialize);
}














